import { PartialPath, State, To } from 'history'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { getProjectId } from 'utilities/get-project-id'

type Params = [To] | [To, { replace?: boolean; state?: State }] | [number]

export const useNavigateProject = () => {
  const navigate = useNavigate()
  return React.useCallback(
    (...[to, options]: Params) => {
      if (typeof to === 'number') {
        return navigate(to)
      }
      return navigate(appendProjectId(to), options)
    },
    [navigate]
  )
}

export const appendProjectId = (to: To): To => {
  const projectId = getProjectId()
  const query = `?projectId=${projectId}`
  if (isPartialPath(to)) {
    return { ...to, search: `${to.search}${query}` }
  }
  return `${to}${query}`
}

function isPartialPath(to: To): to is PartialPath {
  const partialPath = to as PartialPath
  const { hash, pathname, search } = partialPath
  return !hash && !pathname && !search
}
